<style scoped>
.subscriptions-view {
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
  padding: 12px 16px 0;
}

.subscriptions-header {
  text-align: center;
  margin-bottom: 18px;
}

.subscriptions-title {
  color: #0f172a;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

.subscriptions-loading {
  text-align: center;
  color: #526277;
  font-size: 15px;
  padding: 48px 0 24px;
}

.subscriptions-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.subscriptions-footer {
  display: flex;
  justify-content: center;
  margin-top: 18px;
  margin-bottom: 18px;
}

.subscription-card {
  background: #ffffff;
  border: 1px solid #e7edf4;
  border-radius: 20px;
  padding: 22px 20px;
  box-shadow: 0 12px 28px rgba(124, 146, 169, 0.12);
}

.subscription-card__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.subscription-card__eyebrow {
  color: #7a8da5;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;

  margin-bottom: 8px;
}

.subscription-card__number {
  color: #0f172a;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.15;
  word-break: break-word;
}

.subscription-card__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 14px;
  border-radius: 999px;
  background: #eef8f1;
  color: #15803d;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.subscription-card__body {
  border-top: 1px solid #eef2f6;
  padding-top: 16px;
  margin-bottom: 18px;
}

.subscription-card__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.subscription-card__label {
  color: #7a8da5;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}

.subscription-card__value {
  color: #0f172a;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  text-align: right;
}

.subscription-card__actions {
  display: flex;
  justify-content: flex-end;
}

.subscription-card__secondary {
  border: 1px solid #d8e2ed;
  background: #ffffff;
  color: #0f172a;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  padding: 12px 18px;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.subscription-card__secondary:hover {
  border-color: #b8c7d8;
  background: #f8fafc;
}

.empty-state {
  max-width: 520px;
  margin: 0 auto;
  padding: 36px 28px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(124, 146, 169, 0.12);
  text-align: center;
}

.empty-state__title {
  color: #0f172a;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 12px;
}

.empty-state__text {
  color: #526277;
  font-size: 14px;
  line-height: 1.55;
  margin-bottom: 24px;
}

.action-btn {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  border-radius: 14px;
  background: #ed885c;
  border: 1px solid #ed885c;
  padding: 13px 20px;
  text-align: center;
  transition: all 0.25s ease-in-out;
  cursor: pointer;
}

.action-btn:hover {
  background: transparent;
  color: #ed885c;
}

.dialog-card {
  width: 100%;
  max-width: 420px;
  border-radius: 24px;
  padding: 12px;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  text-align: center;
}

.dialog-title {
  color: #0f172a;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.15;
}

.dialog-text {
  color: #526277;
  font-size: 15px;
  line-height: 1.5;
}

.dialog-card-number {
  color: #526277;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
}

.dialog-actions {
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  padding: 8px 16px 8px;
}

.dialog-link {
  border: none;
  background: transparent;
  color: #526277;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}

.dialog-link:hover {
  color: #0f172a;
}

@media (max-width: 640px) {
  .subscriptions-view {
    padding-left: 12px;
    padding-right: 12px;
  }
.subscription-card__number {
  font-size: 14px;
}
  .subscriptions-title {
    font-size: 24px;
  }

  .subscription-card {
    padding: 18px 16px;
  }

  .subscription-card__top,
  .subscription-card__row {
    flex-direction: column;
    align-items: flex-start;
  }

  .subscription-card__value {
    text-align: left;
  }

  .subscription-card__actions {
    justify-content: stretch;
  }

  .subscription-card__secondary {
    width: 100%;
  }

  .subscriptions-footer .action-btn {
    width: 100%;
  }
}

</style>

<template>
  <div class="subscriptions-view">
    <div v-if="loading" class="subscriptions-loading">Загружаем активные подписки...</div>

    <template v-else-if="groupedSubscriptions.length > 0">
      <div class="subscriptions-header">
        <!-- <div class="subscriptions-title">Ваши активные подписки</div> -->
      </div>

      <div class="subscriptions-list">
        <article
          v-for="group in groupedSubscriptions"
          :key="group.key"
          class="subscription-card"
        >
          <div class="subscription-card__top">
            <div>
              <div class="subscription-card__eyebrow">Карта</div>
              <div class="subscription-card__number">{{ group.card }}</div>
            </div>
            <div class="subscription-card__status">Активна</div>
          </div>

          <div class="subscription-card__body">
            <div class="subscription-card__row">
              <div class="subscription-card__label">Дата подписки</div>
              <div class="subscription-card__value">{{ group.subscriptionDate }}</div>
            </div>
          </div>

          <div class="subscription-card__actions">
            <button class="subscription-card__secondary" @click="openConfirm(group)">
              Отписать карту
            </button>
          </div>
        </article>
      </div>

      <div class="subscriptions-footer">
        <button class="action-btn" @click="openSite">
          Подробнее
        </button>
      </div>
    </template>

    <div v-else class="empty-state">
      <div class="empty-state__title">Активных подписок не найдено</div>
      <div class="empty-state__text">
        Вам доступны предложения наших партнеров. Нажмите на кнопку ниже, чтобы перейти к подборке и выбрать подходящий
        вариант.
      </div>
      <button class="action-btn" @click="openSite">Получить деньги</button>
    </div>

    <q-dialog v-model="confirm" persistent>
      <q-card class="dialog-card">
        <q-card-section class="dialog-content">
          <!-- <div class="dialog-title">Отключить подписку?</div> -->
          <div class="dialog-text">
            Вы отключите подписку по карте:
          </div>
          <div class="dialog-card-number">{{ pendingGroup ? pendingGroup.card : '' }}</div>
        </q-card-section>

        <q-card-actions class="dialog-actions">
          <button class="action-btn" @click="closeConfirm">Оставить подписку</button>
          <button class="dialog-link" @click="unsubGroup">Все равно отключить</button>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import * as Subscription from '@/assets/js/bid/subscription_iframe.js';
import { Notify } from 'quasar';

function getStoredPhoneKey() {
  return `unsub_phone_${location.pathname}`;
}

function parseSubscriptionDate(value) {
  if (!value) {
    return 0;
  }

  const match = value.match(/^(\d{2})\.(\d{2})\.(\d{4})(?:\s+(\d{2}):(\d{2}):(\d{2}))?$/);

  if (!match) {
    return 0;
  }

  const [, day, month, year, hours = '00', minutes = '00', seconds = '00'] = match;

  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes),
    Number(seconds)
  ).getTime();
}

export default {
  name: 'SubscriptionsList',

  props: {
    previousPagePromise: Promise,
    backwardPage: Function,
  },

  data: () => ({
    confirm: false,
    phone: '',
    subscriptions: [],
    loading: false,
    pendingGroup: null,
  }),

  computed: {
    groupedSubscriptions() {
      const groups = this.subscriptions.reduce((acc, subscription) => {
        const key = subscription.card || `unknown-${subscription.bid_id || subscription.id}`;

        if (!acc[key]) {
          acc[key] = {
            key,
            card: subscription.card || 'Карта не указана',
            subscriptions: [],
          };
        }

        acc[key].subscriptions.push(subscription);

        return acc;
      }, {});

      return Object.values(groups)
        .map((group) => {
          const subscriptions = [...group.subscriptions].sort(
            (left, right) => parseSubscriptionDate(right.subscribed_at) - parseSubscriptionDate(left.subscribed_at)
          );

          return {
            ...group,
            subscriptions,
            subscriptionDate: subscriptions.length ? subscriptions[0].subscribed_at : 'Дата не указана',
            bidIds: [...new Set(subscriptions.map((subscription) => subscription.bid_id).filter(Boolean))],
          };
        })
        .sort(
          (left, right) => parseSubscriptionDate(right.subscriptionDate) - parseSubscriptionDate(left.subscriptionDate)
        );
    },
  },

  async created() {
    const data = await Promise.resolve(this.previousPagePromise);
    const storedPhone = localStorage.getItem(getStoredPhoneKey());
    const phone = data && data.phone ? data.phone : storedPhone;

    if (!phone) {
      return;
    }

    this.phone = phone;
    localStorage.setItem(getStoredPhoneKey(), phone);
    this.fetchSubscriptions();
  },

  methods: {
    openSite() {
      window.open('https://zaym8.ru', '_blank');
    },

    openConfirm(group) {
      this.pendingGroup = group;
      this.confirm = true;
    },

    closeConfirm() {
      this.confirm = false;
      this.pendingGroup = null;
    },

    async fetchSubscriptions() {
      if (!this.phone) {
        return;
      }

      this.loading = true;

      const result = await Subscription.subscriptions(this.phone);

      this.subscriptions = result.error ? [] : result.subscriptions;
      this.loading = false;
    },

    async unsubGroup() {
      if (!this.pendingGroup || !this.pendingGroup.bidIds.length) {
        this.closeConfirm();
        return;
      }

      const pendingKey = this.pendingGroup.key;

      this.loading = true;

      const results = [];

      for (const bidId of this.pendingGroup.bidIds) {
        const result = await Subscription.unscribe(bidId);
        results.push(result);
      }

      const hasErrors = results.some((result) => result && result.error === 'error');
      const successCount = results.filter(
        (result) => result && result.response && result.error !== 'error'
      ).length;

      this.closeConfirm();
      await this.fetchSubscriptions();

      const stillExists = this.groupedSubscriptions.some((group) => group.key === pendingKey);

      if (!stillExists) {
        Notify.create({
          message: 'Подписка по карте успешно отключена',
          color: 'green',
        });
      } else if (hasErrors && successCount) {
        Notify.create({
          message: 'Часть подписок по карте отключить не удалось',
          color: 'orange',
        });
      } else if (hasErrors) {
        Notify.create({
          message: 'Не удалось отключить подписку по карте',
          color: 'red',
        });
      } else {
        Notify.create({
          message: 'Подписка по карте успешно отключена',
          color: 'green',
        });
      }

      this.loading = false;
    },

    redirectToHome() {
      this.$router.push('/');
    },
  },
};
</script>
